import { Component, OnInit } from '@angular/core';
import { faArrowCircleLeft } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-open-drawer-button',
  templateUrl: './open-drawer-button.component.html',
  styleUrls: ['./open-drawer-button.component.scss']
})
export class OpenDrawerButtonComponent implements OnInit {
  faArrowCircleLeft = faArrowCircleLeft;

  constructor() { }

  ngOnInit() {
  }

}
